import PropTypes from "prop-types";
import { Spinner, Typography } from "../../../themeV2";
import css from "./States.module.css";

export function EmptyState({ query }) {
  return (
    <div className={css.container}>
      <span className={css.symbol}>&#9676;</span>
      <Typography variant="body-lg" color="variant" as="p">
        No results for &ldquo;{query}&rdquo;
      </Typography>
      <Typography variant="label-md" color="variant" as="p">
        Try a different search term
      </Typography>
    </div>
  );
}

EmptyState.propTypes = {
  query: PropTypes.string.isRequired,
};

const words = [
  "Combobulating",
  "Recombobulating",
  "Flibbertigibbetting",
  "Gobbledygookifying",
  "Thingamajigging",
  "Whatchamacalliting",
  "Doodadifying",
  "Doohickeying",
  "Gizmoing",
  "Contraptioning",
  "Hocuspocussing",
  "Ponderizing",
  "Fizzlebusting",
  "Wobblewobbling",
];

function randomWord(list = []) {
  return list[Math.floor(Math.random() * list.length)];
}

export function LoadingState() {
  return (
    <div className={css.container}>
      <span className={css.symbol}>&#9676;</span>
      <div className={css.loadingRow}>
        <Typography variant="body-lg" color="variant" as="p">
          {randomWord(words)}&nbsp;
        </Typography>
        <Spinner size="sm" />
      </div>
    </div>
  );
}
